export default __webpack_public_path__ + "static/media/IconAnimalProfile.0a16bd8d.svg";